module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "my-news-title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "signup",
    attrs: {
      "href": "https://www.vue-js.com/signup"
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "login-key"
  }, [_c('mu-text-field', {
    attrs: {
      "label": "请输入accessToken",
      "errorText": _vm.error,
      "hintText": "accessToken",
      "type": "password",
      "labelFloat": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "登录",
      "primary": ""
    },
    on: {
      "click": _vm.login
    }
  }), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "get-aT"
  }, [_c('mu-raised-button', {
    staticClass: "demo-snackbar-button",
    attrs: {
      "icon": "help_outline",
      "label": "如何获取accessToken"
    },
    on: {
      "click": _vm.showSnackbar
    }
  }), _vm._v(" "), (_vm.snackbar) ? _c('mu-snackbar', {
    attrs: {
      "message": "登录vue.js中文社区，，在设置页面可看到自己的accessToken",
      "action": "关闭"
    },
    on: {
      "actionClick": _vm.hideSnackbar,
      "close": _vm.hideSnackbar
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('FooterNav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e841a10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 142
// module chunks = 1